<template>
  <div class="news-detail-page">
    <!-- 页面Banner -->
    <section class="page-banner news-banner">
      <!-- 数量为1时，显示单张图片 -->
      <div v-if="bannerSlides.length === 1" class="banner-single-bg">
        <img :src="bannerSlides[0].carouselUrl" class="bg-img">
      </div>

      <!-- 数量大于1时，显示轮播幻灯片 -->
      <div v-else-if="bannerSlides.length > 1" class="banner-slider-bg">
        <div v-for="(slide, idx) in bannerSlides" :key="idx" class="bg-slide" :class="{ active: currentBanner === idx }">
          <img :src="slide.carouselUrl" class="bg-img">
        </div>
      </div>

      <div class="container">
        <h1>{{ currentConfig.title }}</h1>
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item 
            v-for="(item, index) in currentConfig.breadcrumb" 
            :key="index"
            :to="item.path ? (item.query ? { path: item.path, query: item.query } : { path: item.path }) : null"
          >
            {{ item.label }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </section>

    <!-- 详情内容区 -->
    <section class="detail-section">
      <div class="container detail-container">
        <div class="detail-main" v-if="newsDetail">
          <div class="detail-header">
            <h2 class="detail-title" v-if="newsDetail.subtitle != null && newsDetail.subtitle != ''" v-html="newsDetail.subtitle"></h2>
            <h2 class="detail-title" v-else>{{ newsDetail.title }}</h2>
            <div class="detail-meta">
              <span v-if="newsDetail.date"><i class="el-icon-date"></i> {{ newsDetail.date }}</span>
              <span v-if="formatDateTime(newsDetail.startTime)"><i class="el-icon-time"></i> 开始时间：{{ formatDateTime(newsDetail.startTime) }}</span>
              <span v-if="formatDateTime(newsDetail.endTime)"><i class="el-icon-time"></i> 结束时间：{{ formatDateTime(newsDetail.endTime) }}</span>
               <span v-if="newsDetail.author != null && newsDetail.author != ''"><i class="el-icon-user"></i> {{ newsDetail.author }}</span>
              <span v-if="newsDetail.source != null && newsDetail.source != ''"><i class="el-icon-collection-tag"></i> {{ newsDetail.source }}</span>
              <span v-if="$store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ newsDetail.visits }} 次浏览</span>
              <span class="infoStatus" v-if="newsDetail.infoStatusLabel" :style="{color: newsDetail.infoStatusColor}"> {{ newsDetail.infoStatusLabel }}</span>
            </div>
          </div>
          
          <div class="detail-body">
            <div class="html-content" v-html="newsDetail.content"></div>
          </div>

          <!-- 上一篇下一篇导航 -->
          <div class="article-nav">
            <div class="prev-article">
               <router-link v-if="prevNews && prevNews.id" :to="{ path: '/news/detail', query: { id: prevNews.id, from: sourceFrom, keyword: keyword || '' } }" style="text-decoration: none;">
                <span class="nav-label"><i class="el-icon-arrow-left"></i> 上一篇</span>
              </router-link>
              <router-link v-if="prevNews && prevNews.id" :to="{ path: '/news/detail', query: { id: prevNews.id, from: sourceFrom, keyword: keyword || '' } }" class="nav-title">
                {{ prevNews.title || '暂无标题' }}
              </router-link>
              <!-- <span v-else class="nav-title empty">没有了</span> -->
            </div>
            <div class="next-article">
               <router-link v-if="nextNews && nextNews.id" :to="{ path: '/news/detail', query: { id: nextNews.id, from: sourceFrom, keyword: keyword || '' } }"  style="text-decoration: none;">
                <span class="nav-label">下一篇 <i class="el-icon-arrow-right"></i></span>
              </router-link>
              <router-link v-if="nextNews && nextNews.id" :to="{ path: '/news/detail', query: { id: nextNews.id, from: sourceFrom, keyword: keyword || '' } }" class="nav-title">
                {{ nextNews.title || '暂无标题' }}
              </router-link>
              <!-- <span v-else class="nav-title empty">没有了</span> -->
            </div>
          </div>
        </div>
        
        <div v-else class="empty-state">
          <!-- 加载中或无数据 -->
          <el-skeleton :rows="10" animated />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getBannerList, getNewsDetail, getPrevNextSolrNews } from '@/api/menu'

export default {
  name: 'NewsDetail',
  data() {
    return {
      bannerSlides: [],
      currentBanner: 0,
      bannerTimer: null,
      newsDetail: null,
      newsId: this.$route.query.id,
      sourceFrom: this.$route.query.from || 'news',
      keyword: this.$route.query.keyword || '',
      sign: this.$route.query.sign || '',
      prevNews: null,
      nextNews: null
    }
  },
  computed: {
    currentConfig() {
      const configs = {
        news: {
          title: '资讯详情',
          breadcrumb: [
            { label: '首页', path: '/' },
            { label: '资讯中心', path: '/news' },
            { label: '资讯详情' }
          ]
        },
        party: {
          title: '党建详情',
          breadcrumb: [
            { label: '首页', path: '/' },
            { label: '企业党建', path: '/party' },
            { label: '党建详情' }
          ]
        },
        assets: {
          title: '资产动态',
          breadcrumb: [
            { label: '首页', path: '/' },
            { label: '资产专区', path: '/assets' },
            { label: '详情内容' }
          ]
        },
        // 可以根据需要增加更多映射
        search: {
          title: '搜索详情',
          breadcrumb: [
            { label: '首页', path: '/' },
            { label: '全文检索', path: '/search' },
            { label: '搜索详情' }
          ]
        }
      };
      return configs[this.sourceFrom] || configs.news;
    }
  },
  watch: {
    '$route.query.id'(newId) {
      if (newId) {
        this.newsId = newId;
        this.fetchNewsDetail();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    '$route.query.keyword'(newKeyword) {
      if (newKeyword) {
        this.keyword = newKeyword;
        if (this.newsDetail && this.newsDetail.infoType) {
          this.fetchPrevNext(this.newsDetail.infoType);
        }
      }
    },
    '$route.query.from'(newFrom) {
      if (newFrom) {
        this.sourceFrom = newFrom;
      }
    }
  },
  created() {
    this.fetchBanner("zxzx");
    if(this.newsId) {
      this.fetchNewsDetail();
    }
  },
  mounted() {
    this.startBannerTimer();
  },
  beforeDestroy() {
    if (this.bannerTimer) {
      clearInterval(this.bannerTimer);
    }
  },
  methods: {
    formatDateTime(val) {
      if (!val || val === 'null' || val === 'undefined') return '';
      const strVal = String(val).trim();
      if (strVal === '') return '';

      // Match YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss
      const match = strVal.match(/^(\d{4})[-/](\d{2})[-/](\d{2})[T ](\d{2}):(\d{2})/);
      if (match) {
        return `${match[1]}-${match[2]}-${match[3]} ${match[4]}:${match[5]}`;
      }

      // Match YYYY-MM-DD
      const dateMatch = strVal.match(/^(\d{4})[-/](\d{2})[-/](\d{2})$/);
      if (dateMatch) {
        return `${dateMatch[1]}-${dateMatch[2]}-${dateMatch[3]}`;
      }

      // Fallback to JS Date parsing
      try {
        const parsedDate = new Date(strVal.replace(/-/g, '/'));
        if (!isNaN(parsedDate.getTime())) {
          const year = parsedDate.getFullYear();
          const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
          const date = String(parsedDate.getDate()).padStart(2, '0');
          const hours = String(parsedDate.getHours()).padStart(2, '0');
          const minutes = String(parsedDate.getMinutes()).padStart(2, '0');
          return `${year}-${month}-${date} ${hours}:${minutes}`;
        }
      } catch (e) {
        console.error('Error parsing date:', e);
      }
      return strVal;
    },
     getOriginalImage(url) {
      if (!url) return '';
      if (url.indexOf("http") === 0) {
        return url;
      }
      return url.replace('_1024x768', '').replace(/\.jpg$/, '');
    },
    startBannerTimer() {
      this.bannerTimer = setInterval(() => {
        if (this.bannerSlides.length > 1) {
          this.currentBanner = (this.currentBanner + 1) % this.bannerSlides.length;
        }
      }, 4000);
    },
    async fetchBanner(groupCode) {
      try {
        const res = await getBannerList({ groupCode })
        if (res.code === 0) {
          this.bannerSlides = res.rows || []
        } 
      } catch (error) {
        console.error('获取轮播图失败', error)
      }
    },
    async fetchNewsDetail() {
      try {
        const res = await getNewsDetail(this.newsId, this.sign)
        if (res.code === 0 || res.code === 200) {
          this.newsDetail = res.data
          if (this.newsDetail && this.newsDetail.infoType && this.sign != '1') {
            this.fetchPrevNext(this.newsDetail.infoType);
          }

          // 设置页面标题
          this.setPageTitle(res.data.title + '-' + currentConfig.title || currentConfig.title)

          // 在 DOM 更新后为图片添加点击事件
          this.$nextTick(() => {
            this.addImageClickEvents();
          });
        }
      } catch (error) {
        console.error('获取新闻详情失败', error)
      }
    },
    setPageTitle(detailTitle) {
      const siteTitle = this.$store.state.siteConfig.showTitle || '辽宁资产管理有限公司'
      document.title = `${detailTitle} - ${siteTitle}`
    },
    addImageClickEvents() {
      const contentElement = document.querySelector('.html-content');
      if (!contentElement) return;
      
      const images = contentElement.querySelectorAll('img');
      images.forEach(img => {
        img.style.cursor = 'pointer';
        img.style.transition = 'transform 0.2s';
        
        img.addEventListener('click', () => {
          const imgSrc = img.getAttribute('src');
          const originalUrl = this.getOriginalImage(imgSrc);
          // 打开原图预览
          this.openImagePreview(originalUrl);
        });
        
        img.addEventListener('mouseenter', () => {
          img.style.transform = 'scale(1.02)';
        });
        
        img.addEventListener('mouseleave', () => {
          img.style.transform = 'scale(1)';
        });
      });
    },
    openImagePreview(url) {
      // 创建一个简单的图片预览弹窗
      const previewDiv = document.createElement('div');
      previewDiv.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        cursor: zoom-out;
      `;
      
      const previewImg = document.createElement('img');
      previewImg.src = url;
      previewImg.style.cssText = `
        max-width: 90%;
        max-height: 90%;
        object-fit: contain;
      `;
      
      previewDiv.appendChild(previewImg);
      
      // 点击关闭
      previewDiv.addEventListener('click', () => {
        document.body.removeChild(previewDiv);
      });
      
      document.body.appendChild(previewDiv);
    },
    async fetchPrevNext(infoType) {
      if (!infoType) {
        console.warn('fetchPrevNext: infoType is required');
        return;
      }
      try {
        const res = await getPrevNextSolrNews(infoType, this.newsId, this.keyword);
        if (res.code === 0 || res.code === 200) {
          this.prevNews = res.data?.prev ?? null;
          this.nextNews = res.data?.next ?? null;
        }
      } catch (error) {
        console.error('获取前后新闻失败', error);
        this.prevNews = null;
        this.nextNews = null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-blue: #1a3a5c;
$text-main: #333;
$text-secondary: #666;
$text-light: #999;
$border: #e8edf3;

/* ---- Banner 头图 ---- */
.page-banner {
  background-size: cover;
  background-color: $primary-blue;
  color: #fff;
  padding: 60px 0;
  position: relative;
  
  .banner-single-bg, .banner-slider-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
  }

  .bg-slide {
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.8s ease;
    &.active { opacity: 1; }
  }

  .bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;
  }

  h1 {
    font-size: 2.2rem;
    font-weight: 600;
    margin: 0 0 15px 0;
    letter-spacing: 2px;
  }
  
  ::v-deep .el-breadcrumb__inner,
  ::v-deep .el-breadcrumb__separator {
    color: rgba(255, 255, 255, 0.8) !important;
  }
  ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: #fff !important;
  }
}

.detail-section {
  padding: 40px 0;
  background-color: #f7f9fa;
  min-height: 50vh;
}

.detail-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.detail-main {
  background: #fff;
  padding: 50px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}

.detail-header {
  border-bottom: 1px solid $border;
  padding-bottom: 25px;
  margin-bottom: 30px;
  text-align: center;
  
  .detail-title {
    font-size: 1.8rem;
    color: $text-main;
    margin: 0 0 20px 0;
    line-height: 1.4;
  }
  
  .detail-meta {
    display: flex;
    justify-content: center;
    gap: 20px;
    color: $text-light;
    font-size: 0.9rem;
    flex-wrap: wrap;
    
    span {
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
}

.detail-body {
  font-size: 1.05rem;
  line-height: 1.8;
  color: $text-secondary;
  
  ::v-deep .html-content {
    overflow-x: auto; /* 允许超出时水平滚动 */
    img {
      max-width: 100% !important;
      height: auto !important;
      margin: 20px auto;
      display: block;
      border-radius: 4px;
    }
    
  }
}

.html-content table {
  margin-left: auto !important;
  margin-right: auto !important;
}

.article-nav {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid $border;
  padding-top: 25px;
  margin-top: 40px;
  
  .prev-article, .next-article {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 48%;
  }
  
  .next-article {
    text-align: right;
    align-items: flex-end;
  }
  
  .nav-label {
    font-size: 0.85rem;
    color: $text-light;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 5px;
  }
  
  .nav-title {
    font-size: 0.95rem;
    color: $text-main;
    text-decoration: none;
    transition: color 0.2s;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
    
    &:hover:not(.empty) {
      color: #b33939; // A reddish shade popular in designs, or use $primary-blue fallback
    }
    
    &.empty {
      color: #bbb;
      cursor: default;
    }
  }
}

.empty-state {
  background: #fff;
  padding: 50px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}

.infoStatus {
  border: 1px solid;
  padding: 1px 5px;
  border-radius: 5px;
}
@media (max-width: 767px) {
  .detail-main {
    padding: 20px 15px;
  }
  .detail-header .detail-title {
    font-size: 1.4rem;
  }

  /* 手机端翻页：改为上下排列，但各自的标签和标题在一行显示 */
  .article-nav {
      flex-direction: column;
      gap: 15px;
      
      .prev-article, .next-article {
          max-width: 100%;
          width: 100%;
          flex-direction: row; /* 水平排列 */
          align-items: center; /* 垂直居中 */
          justify-content: flex-start; /* 全部左对齐 */
          text-align: left; /* 重置PC端的右对齐，确保文本靠左 */
      }
      
      .prev-article > a:first-child, 
      .next-article > a:first-child {
          flex-shrink: 0; /* 防止“上一篇”文本被长标题挤压变形 */
      }

      .nav-label {
          margin-bottom: 0;
      }

      .nav-title {
          white-space: nowrap;     /* 标题单行显示 */
          overflow: hidden;        /* 超出部分隐藏 */
          text-overflow: ellipsis; /* 超出部分显示省略号 */
          flex: 1;                 /* 撑满剩余屏幕宽度 */
          min-width: 0;            /* 关键：修复 flex 布局下文字截断失效的问题 */
      }
  }
}
</style>
